// import React from 'react'
// import { Link } from 'gatsby'
// import footerBg from '../static/images/FooterBG.svg'

// const Footer = () => {
//   const footerData = [
//     {
//       title: "Home",
//       links: [
//         { name: "Challenge Overview", path: "/#challenge" },
//         { name: "Testimonial", path: "/#testimonial" },
//         { name: "Awards", path: "/#awards" },
//         { name: "Who We Empower", path: "/#empower" },
//         { name: "Insights", path: "/blog" }
//       ]
//     },
//     {
//       title: "Products",
//       links: [
//         { name: "FAM (Fixed Asset Management)", path: "/products/fam" },
//         { name: "ITAM (IT Asset Management)", path: "/products/itam" },
//         { name: "ITSM (IT Service Management)", path: "/products/itsm" },
//         { name: "Remote Management", path: "/products/remote-desktop/" },
//         { name: "Patch Management", path: "/products/patch-management" },
//         { name: "Property Management", path: "/products/property-management" },
//         { name: "Network Monitoring & Management", path: "/products/network-monitoring" }
//       ]
//     },
//     {
//       title: "Solutions",
//       links: [
//         { name: "Cost Optimization", path: "/solutions/cost-optimization/" },
//         { name: "Regulatory Compliance", path: "/solutions/regulatory-compliance/" },
//         { name: "Operational Efficiency", path: "/solutions/operational-efficiency/" },
//         { name: "Digital Transformation", path: "/solutions/digital-transformation/" }
//       ]
//     },
//     {
//       title: "Links",
//       links: [
//         { name: "Blog", path: "/resources/" },
//         { name: "Case Studies", path: "/careers/" },
//         { name: "Documentation", path: "/documentation" }
//       ]
//     }
//   ];

//   return (
//     <footer className="relative w-full overflow-hidden">
//       <style dangerouslySetInnerHTML={{ __html: `
//         .footer-bg-layer {
//           background-image: url(${footerBg}), radial-gradient(41.05% 82.11% at 50% 100%, rgba(142, 139, 231, 0.13) 0%, rgba(174, 159, 241, 0.13) 25%, rgba(205, 179, 251, 0.13) 50%, rgba(255, 255, 255, 0.13) 100%);
//           background-position: center bottom, center;
//           background-repeat: no-repeat;
//           background-size: contain, cover; 
//         }
//         @media (min-width: 768px) {
//           .footer-bg-layer {
//             background-size: 700px auto, auto; 
//           }
//         }
//       `}} />
//       <div className="footer-bg-layer absolute inset-0 z-0 pointer-events-none" />
//       <div className="relative z-10 px-[20px] md:px-[30px] lg:px-[120px] 
//                       h-[350px] overflow-y-auto md:h-auto md:overflow-visible 
//                       scrollbar-hide">
        
//         <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-[40px] md:gap-12 pt-[40px] pb-[100px] md:pb-[60px]">
          
//           {footerData.map((column) => (
//             <div key={column.title} className="flex flex-col gap-6">
//               <div className="font-[500] text-[20px] md:text-[22px] text-[#252625] font-neue">
//                 {column.title}
//               </div>
//               <ul className="flex flex-col gap-4 font-neue">
//                 {column.links.map((link) => (
//                   <li key={link.name}>
//                     <Link 
//                       to={link.path} 
//                       className="text-[#252625] text-[14px] hover:text-[#666CFF] hover:translate-x-1 transition-all duration-300 inline-block"
//                     >
//                       {link.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//           <div className="flex flex-col gap-6">
//             <h4 className="font-[500] text-[20px] md:text-[22px] text-[#252625]">Quick Connect</h4>
//             <div className="text-[#252625] text-[14px] flex flex-col justify-center gap-5">
//               <a href="mailto:admin@meltxsoftware.com" className="flex items-center gap-[10px] hover:text-[#666CFF] transition-all duration-300 w-fit">
//                 <span className="material-symbols-outlined">mail</span>
//                 <span>admin@meltxsoftware.com</span>
//               </a>
//               <a href="tel:+912069011061" className="flex items-center gap-[10px] hover:text-[#666CFF] transition-all duration-300 w-fit">
//                 <span className="material-symbols-outlined">phone_in_talk</span>
//                 <span>020 69011061</span>
//               </a>
//               <a href="#" className="flex items-start gap-[10px] hover:text-[#666CFF] transition-all duration-300 max-w-[280px]">
//                 <span className="material-symbols-outlined">location_on</span>
//                 <span className="leading-relaxed">
//                   Office No. 210, 211, 212. Second floor, Aston Plaza, Ambegaon Bk, Pune 411 046
//                 </span>
//               </a>
//             </div>
//           </div>

//         </div>
//       </div>
//     </footer>
//   )
// }

// export default Footer
import React from 'react'
import { Link } from 'gatsby'
import footerBg from '../static/images/FooterBG.svg'

const Footer = () => {
  const footerData = [
    // {
    //   title: "Home",
    //   links: [
    //     { name: "Challenge Overview", path: "/#challenge" },
    //     { name: "Testimonial", path: "/#testimonial" },
    //     { name: "Awards", path: "/#awards" },
    //     { name: "Who We Empower", path: "/#empower" },
    //     { name: "Insights", path: "/blog" }
    //   ]
    // },
    {
      title: "Products",
      links: [
        { name: "FAM (Fixed Asset Management)", path: "/products/fam" },
        { name: "ITAM (IT Asset Management)", path: "/products/itam" },
        { name: "ITSM (IT Service Management)", path: "/products/itsm" },
        { name: "Remote Management", path: "/products/remote-desktop/" },
        // { name: "Patch Management", path: "/products/patch-management" },
        // { name: "Property Management", path: "/products/property-management" },
        // { name: "Network Monitoring & Management", path: "/products/network-monitoring" }
      ]
    },
    {
      title: " ",
      links: [
        // { name: "FAM (Fixed Asset Management)", path: "/products/fam" },
        // { name: "ITAM (IT Asset Management)", path: "/products/itam" },
        // { name: "ITSM (IT Service Management)", path: "/products/itsm" },
        // { name: "Remote Management", path: "/products/remote-desktop/" },
        { name: "KYC Management", path: "/products/kyc/" },
        { name: "Customizable Solutions", path: "/products/customizablesolution/" },
        { name: "Property Management", path: "/products/property-management" },
        { name: "Integrated Services", path: "/products/integratedservices/" }
      ]
    },
    // {
    //   title: "Solutions",
    //   links: [
    //     { name: "Cost Optimization", path: "/solutions/cost-optimization/" },
    //     { name: "Regulatory Compliance", path: "/solutions/regulatory-compliance/" },
    //     { name: "Operational Efficiency", path: "/solutions/operational-efficiency/" },
    //     { name: "Digital Transformation", path: "/solutions/digital-transformation/" }
    //   ]
    // },
    // {
    //   title: "Links",
    //   links: [
    //     { name: "Blog", path: "/resources/" },
    //     { name: "Case Studies", path: "/careers/" },
    //     { name: "Documentation", path: "/documentation" }
    //   ]
    // }
  ];

  return (
    <footer className="relative w-full overflow-hidden">
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes slideGradient {
          0% { background-position: center bottom, 0% 100%; }
          100% { background-position: center bottom, 100% 100%; }
        }

        .footer-bg-layer {
          /* Your exact radial gradient logic */
          background-image: url(${footerBg}), radial-gradient(41.05% 82.11% at 50% 100%, rgba(142, 139, 231, 0.13) 0%, rgba(174, 159, 241, 0.13) 25%, rgba(205, 179, 251, 0.13) 50%, rgba(255, 255, 255, 0.13) 100%);
          
          /* The SVG stays centered bottom, the gradient starts moving from the left */
          background-position: center bottom, 0% 100%;
          background-repeat: no-repeat;

          /* We set the gradient width to 200% so it has 'room' to slide left/right */
          background-size: contain, 200% 100%; 
          
          /* Move back and forth infinitely */
          animation: slideGradient 10s ease-in-out infinite alternate;
        }

        @media (min-width: 768px) {
          .footer-bg-layer {
            /* Kept your image size logic and kept the 200% width for the gradient */
            background-size: 700px auto, 200% 100%; 
          }
        }
      `}} />
      <div className="footer-bg-layer absolute inset-0 z-0 pointer-events-none" />
      <div className="relative z-10 px-[20px] md:px-[30px] lg:px-[120px] 
                      h-[350px] overflow-y-auto md:h-auto md:overflow-visible 
                      scrollbar-hide">
        
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-[40px] md:gap-12 pt-[40px] pb-[100px] md:pb-[60px]">
          
          {footerData.map((column) => (
            <div key={column.title} className="flex flex-col gap-6">
              <div className="font-[500] text-[20px] md:text-[22px] text-[#252625] font-neue">
                {column.title}
              </div>
              <ul className="flex flex-col gap-4 font-neue">
                {column.links.map((link) => (
                  <li key={link.name}>
                    <Link 
                      to={link.path} 
                      className="text-[#252625] text-[14px] hover:text-[#666CFF] hover:translate-x-1 transition-all duration-300 inline-block"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="flex flex-col gap-6">
            <h4 className="font-[500] text-[20px] md:text-[22px] text-[#252625]">Quick Connect</h4>
            <div className="text-[#252625] text-[14px] flex flex-col justify-center gap-5">
              <a href="mailto:admin@meltxsoftware.com" className="flex items-center gap-[10px] hover:text-[#666CFF] transition-all duration-300 w-fit">
                <span className="material-symbols-outlined">mail</span>
                <span>admin@meltxsoftware.com</span>
              </a>
              <a href="tel:+912069011061" className="flex items-center gap-[10px] hover:text-[#666CFF] transition-all duration-300 w-fit">
                <span className="material-symbols-outlined">phone_in_talk</span>
                <span>020 69011061</span>
              </a>
              <a href="#" className="flex items-start gap-[10px] hover:text-[#666CFF] transition-all duration-300 max-w-[280px]">
                <span className="material-symbols-outlined">location_on</span>
                <span className="leading-relaxed">
                  Office No. 210, 211, 212. Second floor, Aston Plaza, Ambegaon Bk, Pune 411 046
                </span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </footer>
  )
}

export default Footer